import { useEffect, useRef, useState } from 'react';

export const useResizer = (): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 900);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};

export const useContainerWidth = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            if (entries[0]) {
                setWidth(entries[0].contentRect.width);
            }
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            const currentRef = ref.current;
            if (currentRef) {
                observer.disconnect();
            }
        };
    }, []);

    return { ref, width };
};